import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import OrderItems from './orderItems';
import Button from '@material-ui/core/Button';

const footerStyle = {
  fontSize: '20px',
  color: 'white',
  backgroundColor: 'white',
  textAlign: 'center',
  padding: '10px',
  position: 'fixed',
  left: '0',
  bottom: '0',
  paddingTop: '0px',
  height: '60px',
  width: '100%',
};

const phantomStyle = {
  display: 'block',
  padding: '20px',
  height: '60px',
  width: '100%',
};

class confirmOrder extends Component {
  state = {
    total: 0,
  };

  componentDidMount = () => {
    const { order } = this.props;

    var count = 0;
    order.map((item) => (count += parseFloat(item.price)));
    this.setState({
      total: parseFloat(count).toFixed(2),
    });
  };

  render() {
    const { order, total } = this.props;

    return (
      <div style={{ maxWidth: '410px', margin: '0 auto' }}>
        {/* <Link to={{
                    pathname:'/checkout/order/Chuys'
                }}>
                Confirm Order
                </Link> */}

        <OrderItems order={order} />

        {/* <BotNav/>
                <CssBaseline/> */}
        <div style={phantomStyle} />
        <div style={footerStyle}>
          {' '}
          <Button
            style={{
              backgroundColor: 'rgb(242 243 244)',
              width: '90%',
              height: '47px',
            }}
          >
            Continue{' '}
            <Typography
              style={{
                textAlign: 'right',
                marginTop: '-3.5vh',
                paddingRight: '4vw',
              }}
            >
              ${total}
            </Typography>
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    order: state.data.order,
    total: state.data.total,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(confirmOrder);
